"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.matchDIDPattern = exports.addressOf = exports.hexify = exports.encodedPubKeyName = exports.signerPubKey = exports.walletPubKey = exports.compressedSecp256k1KeyLength = void 0;
const keys_1 = require("@ew-did-registry/keys");
const ethers_1 = require("ethers");
const did_resolver_interface_1 = require("@ew-did-registry/did-resolver-interface");
const { keccak256, hashMessage, arrayify, computePublicKey, recoverPublicKey, hexlify, } = ethers_1.utils;
const didPattern = '^did:[a-z0-9]+?:?[a-z0-9]+?:(0x[A-Fa-f0-9]{40})$';
exports.compressedSecp256k1KeyLength = 66;
const walletPubKey = ({ privateKey }) => new keys_1.Keys({ privateKey: privateKey.slice(2) }).publicKey;
exports.walletPubKey = walletPubKey;
function signerPubKey(signer) {
    return __awaiter(this, void 0, void 0, function* () {
        const msg = hexlify(123);
        const hash = keccak256(msg);
        const digest = hashMessage(arrayify(hash));
        const signature = yield signer.signMessage(arrayify(digest));
        return computePublicKey(recoverPublicKey(digest, signature), true).slice(2);
    });
}
exports.signerPubKey = signerPubKey;
function encodedPubKeyName(encoding) {
    switch (encoding) {
        case did_resolver_interface_1.Encoding.HEX:
            return 'publicKeyHex';
        case did_resolver_interface_1.Encoding.BASE64:
            return 'publicKeyBase64';
        case did_resolver_interface_1.Encoding.PEM:
            return 'publicKeyPem';
        default:
            return 'publicKeyHex';
    }
}
exports.encodedPubKeyName = encodedPubKeyName;
function hexify(value) {
    if (typeof value === 'string' && value.startsWith('0x')) {
        return value;
    }
    return `0x${Buffer.from(typeof value === 'string' ? value : JSON.stringify(value)).toString('hex')}`;
}
exports.hexify = hexify;
/**
 * Checks if did is valid, and returns the address if it is
 *
 * @param did
 */
function addressOf(did) {
    const match = did.match(didPattern);
    if (!match) {
        throw new Error('Invalid DID');
    }
    return match[1];
}
exports.addressOf = addressOf;
/**
 * Checks if did has a valid pattern, and returns the matched pattern array if it is
 *
 * @param did
 */
function matchDIDPattern(did) {
    const match = did.match(didPattern);
    if (!match) {
        throw new Error('Invalid DID');
    }
    return match;
}
exports.matchDIDPattern = matchDIDPattern;
//# sourceMappingURL=crypto.js.map